<template>
  <Dialog
    v-model:visible="showModal"
    class="w-11/12 lg:w-3/5 bg-white shadow rounded-xl"
    :modal="true"
  >
    <template #header>
      <div class="w-full text-gray-900 font-semibold">
        {{lang['components']['Dialog']['PayRecordDialog']['payment_record_title_text']}}
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-2 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2"
          @click="changePlan"
        >
        {{lang['components']['Dialog']['PayRecordDialog']['payment_record_modify_plan_button']}}
      </button>
      </div>
    </template>
    <div v-if="false" class="flex flex-wrap justify-center">
      <div
        class=" bg-white rounded-xl flex items-center w-2/3 p-2 shadow-sm border border-gray-200"
      >
        <i class="pi pi-search"></i>
        <input
          type="search"
          class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
        />
      </div>
      <button
        class="text-white px-4 whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900 ml-4"
      >
        搜尋
      </button>
    </div>
    <div
      class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-2 lg:px-8 pt-3 rounded-bl-lg rounded-br-lg"
    >
      <DataTable
        class="p-datatable-customers"
        :value="plansListData"
        :paginator="true"
        :rows="5"
        v-model:filters="filters"
        filterDisplay="menu"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 20, 50]"
        :globalFilterFields="['id','time','state']"
        responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      >
        <template #header class="bg-white">
          <div class="p-d-flex p-jc-between p-ai-center w-full bg-white">
            <span class="p-input-icon-left w-full">
              <i class="pi pi-search" />
              <InputText v-model="filters['global'].value" placeholder="Keyword Search" class="w-full rounded-md" />
            </span>
          </div>
        </template>
        <Column field="id" :header="lang['components']['Dialog']['PayRecordDialog']['payment_record_table_field_1']"></Column>
        <Column field="time" :header="lang['components']['Dialog']['PayRecordDialog']['payment_record_table_field_2']"></Column>
        <Column field="state" :header="lang['components']['Dialog']['PayRecordDialog']['payment_record_table_field_3']"></Column>
        <Column header="">
          <template #body="{data}">
            <button
              class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out border-2"
              @click="detailData(data.no_id, data.type)"
            >
              {{lang['components']['Dialog']['PayRecordDialog']['payment_record_table_check_text']}}
            </button>
            <button
              class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2"
              @click="showLevelUp = true"
              v-if="false"
            >
              查看（跳出升級）
            </button>
          </template>
        </Column>
      </DataTable>
    </div>
    <template #footer> </template>
  </Dialog>
  <OrderDetailDialog :list="details" v-bind:lang="lang" v-model:show="showDetail" />
  <ActivePlenItemDialog v-bind:lang="lang" v-bind:userStatus="userStatus" v-model:show="showActiveDetail" @closeModal="closeModal" />
</template>

<script>
import Dialog from "primevue/dialog";
import ActivePlenItemDialog from "./ActivePlenItemDialog.vue";
import OrderDetailDialog from "./OrderDetailDialog.vue";
import LevelUpDialog from "./LevelUpDialog.vue";
import InputText from 'primevue/inputtext'
import { FilterMatchMode, FilterOperator } from "primevue/api"
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "PayRecordDialog",
  components: {
    Dialog,
    ActivePlenItemDialog,
    OrderDetailDialog,
    LevelUpDialog,
    InputText,
    DataTable,
    Column
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    plansList:{
      type:Object,
    },
    userStatus: {
      type:String,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      showDetail: false,
      showActiveDetail: false,
      showLevelUp: false,
      details: [],
      payRecordList: [],
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
        id: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        time: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        state: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        }
      }
    };
  },
  methods: {
    detailData(id, type) {
      // console.log('id:'+id);
      // console.log('type:'+type);

      if(id != '' && id != 'undefined' && type != '' && type != 'undefined'){
         axios
          .post('https://www.autoturn.net/api/payment_details.php', Qs.stringify({
            s_code: this.$route.params.id,
            no: id,
            form: type
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.details = response.data.return_data

              // console.log('this.details');
              // console.log(this.details);

              this.showDetail = true
            }
          });
      }
    },
    changePlan(){
      // Swal.fire({
      //   icon: 'warning',
      //   title: this.lang['components']['Dialog']['PayRecordDialog']['axios']['swal_title'],
      //   text: this.lang['components']['Dialog']['PayRecordDialog']['axios']['swal_text'],
      //   showDenyButton: false,
      //   showCancelButton: false,
      //   confirmButtonText: this.lang['components']['Dialog']['PayRecordDialog']['axios']['yes_button']
      //   // denyButtonText: `Don't save`,
      // }).then((result) => {
      //   window.open('https://m.me/1055506187980947','autoturn','width=1024,height=768');
      // })

      this.showActiveDetail = true;
    },
    closeModal(){
      this.showModal = false
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function(value) {
        this.$emit("update:show", value);
      }
    },
    plansListData: {
      get: function () {
        return this.plansList
      },
      set: function (value) {
        this.$emit('update:plansList', value)
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-datatable {
    tr button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }

  .p-datatable .p-datatable-thead > tr > th {
    background: transparent !important;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr > td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  }
}
</style>
